import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import './ThemedConfirmDialog.css';

const ThemedConfirmDialog = ({
  open,
  title,
  message,
  cancelLabel,
  confirmLabel,
  confirmBusyLabel,
  onCancel,
  onConfirm,
  busy,
  confirmDisabled,
  disableEscapeKeyDown,
  children,
}) => (
  <Dialog
    open={!!open}
    onClose={busy ? undefined : onCancel}
    aria-labelledby="themed-confirm-title"
    aria-describedby="themed-confirm-description"
    disableEscapeKeyDown={!!disableEscapeKeyDown || !!busy}
    PaperProps={{ className: 'themed-confirm-dialog' }}
  >
    <DialogTitle
      id="themed-confirm-title"
      className="themed-confirm-title"
      disableTypography
    >
      <Typography variant="subtitle1">{title}</Typography>
      <IconButton
        aria-label="Close"
        className="themed-confirm-close"
        onClick={onCancel}
        disabled={busy}
        size="large"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent className="themed-confirm-content">
      <DialogContentText
        id="themed-confirm-description"
        className="themed-confirm-text"
      >
        {message}
      </DialogContentText>
      {children ? <Box sx={{ mt: 2 }}>{children}</Box> : null}
    </DialogContent>
    <DialogActions className="themed-confirm-actions">
      <Button
        className="themed-confirm-secondary"
        onClick={onCancel}
        disabled={busy}
      >
        {cancelLabel}
      </Button>
      <Button
        className="themed-confirm-primary"
        onClick={onConfirm}
        disabled={busy || confirmDisabled}
        startIcon={
          busy ? <CircularProgress size={16} color="inherit" /> : null
        }
      >
        {busy && confirmBusyLabel ? confirmBusyLabel : confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ThemedConfirmDialog;



// WEBPACK FOOTER //
// ./src/components/common/ThemedConfirmDialog.js